// components/AboutUs.js
import React, { useEffect } from 'react';
import '../Styles/About.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

function About() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <section className="aboutus-section" id="about">
      <div className="container">
        <div className="row align-items-center">
          {/* Image */}
          <div
            className="col-lg-6 mb-4 mb-lg-0"
            data-aos="fade-right"
          >
            <img
              src="https://img.freepik.com/free-vector/business-growth-concept-with-rocket_23-2148786484.jpg"
              alt="About IQube"
              className="img-fluid rounded shadow"
            />
          </div>

          {/* Text Content */}
          <div
            className="col-lg-6"
            data-aos="fade-left"
          >
            <h2 className="section-title">
              About <span className="highlight">IQube Technologies</span>
            </h2>
            <p className="lead">
              At IQube Technologies, we specialize in driving innovation and delivering high-quality software solutions that scale with your business. With a focus on modern engineering practices and a customer-first mindset, we provide services that empower startups and enterprises alike.
            </p>
            <p>
              Our team of seasoned engineers, designers, and strategists are passionate about technology and solving complex business problems through creativity, collaboration, and cutting-edge tools.
            </p>
            <ul className="about-list">
              <li> 10+ years in business</li>
              <li> Trusted by top global tech companies</li>
              <li> Agile & scalable technology services</li>
              <li> Expertise in GraphQL, GCP, Microservices, UI/UX, and more</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
